import React from 'react';

import { formatLinkBlockToUrl } from '$utilities/format';
import { isLocalURL } from '$utilities/browser';
import { usePage } from '$contexts/page.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').GenericCardsBlock}
 */
const GenericCards = ({
    backgroundColor,
    buttons,
    cards,
    id,
    richText,
    title
}) => {
    const { page } = usePage();

    return (
        <section className={`col-wrapper-breakout bg-surface-panel-${backgroundColor} rounded-lg pb-8 md:pb-16 pt-24`}>
            <h2 className='col-padding type-style-sans-h1 w-full sm:w-8/12 md:w-7/12'>
                {title}
            </h2>

            {richText && (
                <div
                    className='col-padding rich-text type-style-sans-h3 mt-8 w-full sm:w-7/12 md:w-5/12'
                    dangerouslySetInnerHTML={{ __html: richText }} />
            )}

            <div className='col-padding mt-24 md:mt-40 sm:grid-cols-4 gap-8 md:gap-16 grid'>
                {cards.map((partner) => {
                    return (
                        <div
                            className='bg-surface-raised p-16 rounded-lg grid grid-y-16 grid-rows-subgrid'
                            key={partner.id}
                            style={{ gridRow: 'span 2'}}>
                            <p className='type-style-sans-h3-med'>
                                {partner.title}
                            </p>

                            {partner.text && (
                                <p className='type-style-sans-body'>
                                    {partner.text}
                                </p>
                            )}
                        </div>
                    );
                })}
            </div>

            {buttons?.length > 0 && (
                <div className='col-padding mt-24 sm:mt-40 flex flex-wrap gap-x-8'>
                    {buttons.map((button, idx) => {
                        const isCtaLinkLocal = isLocalURL(formatLinkBlockToUrl(button.ctaLink));

                        return (
                            <React.Fragment key={idx}>
                                {button.ctaMobileUrlOverride ? (
                                    <>
                                        <a
                                            className={`sm:hidden ${idx === 0 ? 'button-primary-xl' : 'button-outcome-xl'}`}
                                            data-analytics-action='click'
                                            data-analytics-context={title}
                                            data-analytics-destination={button.ctaMobileUrlOverride}
                                            data-analytics-id={`${page?.id}_${id}_generic_cards_cta_${idx}`}
                                            data-analytics-label={button.ctaLabel}
                                            data-analytics-location='modules'
                                            data-analytics-module='generic_cards_cta'
                                            href={button.ctaMobileUrlOverride}
                                            rel='noreferrer'
                                            target='_blank'>
                                            {button.ctaLabel}
                                        </a>
                                        <a
                                            className={`hidden sm:inline-block ${idx === 0 ? 'button-primary-xl' : 'button-outcome-xl'}${button.ctaCssClass ? ' ' + button.ctaCssClass : ''}`}
                                            data-analytics-action='click'
                                            data-analytics-context={title}
                                            data-analytics-destination={formatLinkBlockToUrl(button.ctaLink)}
                                            data-analytics-id={`${page?.id}_${id}_generic_cards_cta_${idx}`}
                                            data-analytics-label={button.ctaLabel}
                                            data-analytics-location='modules'
                                            data-analytics-module='generic_cards_cta'
                                            href={formatLinkBlockToUrl(button.ctaLink)}
                                            rel={isCtaLinkLocal ? undefined : 'noreferrer'}
                                            target={isCtaLinkLocal ? undefined : '_blank' }>
                                            {button.ctaLabel}
                                        </a>
                                    </>
                                ) : (
                                    <a
                                        className={`${idx === 0 ? 'button-primary-xl' : 'button-outcome-xl'}${button.ctaCssClass ? ' ' + button.ctaCssClass : ''}`}
                                        data-analytics-action='click'
                                        data-analytics-context={title}
                                        data-analytics-destination={formatLinkBlockToUrl(button.ctaLink)}
                                        data-analytics-id={`${page?.id}_${id}_generic_cards_cta_${idx}`}
                                        data-analytics-label={button.ctaLabel}
                                        data-analytics-location='modules'
                                        data-analytics-module='generic_cards_cta'
                                        href={formatLinkBlockToUrl(button.ctaLink)}
                                        rel={isCtaLinkLocal ? undefined : 'noreferrer'}
                                        target={isCtaLinkLocal ? undefined : '_blank' }>
                                        {button.ctaLabel}
                                    </a>
                                )}
                            </React.Fragment>
                        );
                    })}
                </div>
            )}
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default GenericCards;
